// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { DnaSyngoviaGroupNode } from '../interfaces/dna-syngovia-group-node';
import { DnaSyngoviaNodeType } from '../interfaces/dna-syngovia-node';
import { DnaSyngoviaSelectionType } from './dna-syngovia-selection-model';

export class DnaSyngoviaGroupNodeSelectionModel {
  public groupNode: DnaSyngoviaGroupNode;
  public selection: DnaSyngoviaSelectionType[];

  public constructor(groupNode: DnaSyngoviaGroupNode) {
    this.groupNode = groupNode;
    this.selection = this.groupNode.nodes.map((node) => ({
      value: node,
      selected: false,
    }));
  }

  public isAllSelected(): boolean {
    const notSelectedNode = this.selection.find(
      (element) => element.selected === false
    );
    return notSelectedNode === undefined;
  }

  public select(node: DnaSyngoviaNodeType): void {
    const selection = this.findNodeSelection(node);
    if (selection) {
      selection.selected = true;
    }
  }

  private findNodeSelection(node: DnaSyngoviaNodeType) {
    return this.selection.find((element) => element.value === node);
  }

  public deselectAll(): void {
    this.selection.forEach((element) => (element.selected = false));
  }

  public updateSelection(selectedNodes: DnaSyngoviaNodeType[]): void {
    if (selectedNodes) {
      selectedNodes.forEach((node) => this.select(node));
    }
  }
}
